// eslint-disable-next-line import/prefer-default-export
export const LOGIN = { // 登录
  LOGIN: '/icmp/loginRestFacade/login'
}
export const EDITPASS = { // 修改密码
  updatePwd: '/icmp/loginRestFacade/changePassword'
}
export const GETMENULIST = { // 获取权限
  GETMENU: '/icmp/loginRestFacade/permissionMenu'
}
export const LOGOUT = { // 退出登录
  LOGOUT: '/icmp/loginRestFacade/logout'
}
export const DELIVERY_RECORD = { // 配送记录
  GET_LIST: '/deliveryRecord/findList',
  DOWNLOAD: '/deliveryRecord/derive',
  UPDATE: '/deliveryRecord/update',
  INSERTRECORD: '/deliveryRecord/insertRecord',
  FINDHISTORY: '/deliveryRecord/findHistory',
  RECORDFINDLIST: '/recordDetails/findList',
  RESEND: '/ResendMessage/resend'
}
export const DEVICE_MANAGE = { // 设备管理
  GET_LIST: '/deviceManage/getlist',
  ADD_LIST: '/deviceManage/insert',
  DEL_LIST: '/deviceManage/delList',
  FIND_BY_ID: '/deviceManage/findById',
  EDIT_LIST: '/deviceManage/update',
  RESTAET_LIST: '/deviceManage/restart',
  GET_DEVICENUM: '/deviceManage/ifExist',
  DEL_CHECK: '/deviceManage/getStatus',
  CLIENT_DOWNLOAD_LOG: '/deviceManage/downLog',
  FIND_LOG: '/deviceManage/findLog',
  INSERT_LOG: '/deviceManage/insertLog',
  DELETEFILE: '/deviceManage/deleteFile',
  CLEARLOG: '/deviceManage/clearLog'
}
export const DOOR_MANAGE = { // 柜门管理
  GET_LIST: '/cabinetDoor/findList',
  UPDATESTATE: 'cabinetDoor/updateStatus'
}
export const UNPACKLOG = { // 开箱日志
  GET_LIST: '/packing/findList'
}
export const SHORT_MESSAGE_LOG = { // 信息发送日志
  GET_LIST: '/smsSend/findList'
}
export const ROLE_MANAGE = { // 角色管理
  GET_LIST: '/roleManage/findList',
  ADD_LIST: '/roleManage/insert',
  EDIT_LIST: '/roleManage/update',
  DEL_LIST: '/roleManage/delete',
  DEL_CHECK: '/roleManage/ifExist',
  FOBBIDEN_LIST: '/roleManage/forbidden',
  FIND_ROLE_ID: '/roleManage/findMenu'
}
export const BACK_STATE_MANAGE = { // 用户管理 // 配送员管理
  GET_LIST: '/userManage/findList',
  ADD_LIST: '/userManage/insert',
  FIND_ROLE: '/userManage/findRole',
  EDIT_LIST: '/userManage/update',
  DEL_LIST: '/userManage/delete',
  FOBBIDEN_LIST: '/userManage/forbidden',
  FINDUSERROLE: '/userManage/findUserRole',
  UPLOADUSERMODEL: '/userManage/upload'
}
export const STORERETURNRECORD = { // 退料记录
  GET_LIST: '/rejectedRecord/findList',
  UPDATE: '/rejectedRecord/update',
  FINDHISTORY: '/rejectedRecord/findHistory',
  DOWNLOAD: '/rejectedRecord/derive',
  INSERTRECORD: '/rejectedRecord/insertRecord',
  RECORDFINDLIST: '/recordDetails/findList',
  RESEND: '/ResendMessage/resend',
  EDITPHONE: '/rejectedRecord/updateNoticePhone',
  GETSYSTEMCONFIG: '/sysConfig/findList'
}
export const SYSCONFIG = { // 系统配置
  GET_LIST: '/sysConfig/findList',
  RESTART: '/sysConfig/restart',
  SAVE: '/sysConfig/save',
  MSG_CONFIG_GET: '/msgConfig/get', // 查询阿里云短信配置
  MSG_CONFIG_SAVE: '/msgConfig/save' // 保存阿里云短信配置
}

export const VERSIONMANAGE = { // 客户端版本管理
  GET_LIST: '/VersionManage/findList',
  UPLOAD: '/VersionManage/upload',
  PACKAGESTATUS: '/VersionManage/update' // 上下架
}
